import React, { useEffect } from "react";
import { FaArrowRight } from 'react-icons/fa';
import Testimonials from "../components/Testimonials";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
        useEffect(() => {
            window.scrollTo(0, 0);
            AOS.init({ duration: 1000 });
        }, []);
        const navigate=useNavigate();
    return (
        <>
            <div className="relative bg-[url('https://themewagon.github.io/Mentor/assets/img/hero-bg.jpg')] bg-cover bg-center py-12 px-6 md:px-16 lg:px-24 h-96 flex items-center">
                <div className="absolute inset-0 bg-black opacity-10 z-0"></div>
                <div className="relative max-w-4xl text-left text-white z-10" data-aos="fade-up">
                    <h2 className="text-xl md:text-4xl font-bold mb-4">
                        Learning Today, <br /> Leading Tomorrow
                    </h2>
                    <p className="text-lg md:text-xl mb-6" >
                        Cultivating curiosity, critical thinking, and leadership for future success.
                    </p>
                    <button onClick={()=>{
                            navigate('/contact')
                        }} className="bg-white text-green-500 rounded-full py-3 px-6 font-medium cursor-pointer 
                   transition-all duration-300 ease-in-out hover:bg-green-500 hover:text-white">
                        Get Started
                    </button>

                </div>

            </div>

            <div className="container mx-auto px-6 py-12">


                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8" data-aos="fade-up">
                    {/* Left Side - Text Content */}
                    <div className="lg:w-1/2 text-left">
                        <h2 className="text-xl md:text-2xl font-bold text-green-600 mb-4">
                            WELCOME TO SVN CONVENT AND ENGLISH HIGH SCHOOL
                        </h2>
                        <p className="text-gray-700 text-lg leading-relaxed">
                            At SVN Convent and English High School, we believe that education is about
                            preparing children for the world beyond textbooks. We strive to
                            impart knowledge and instill integrity, courage, resilience, and
                            empathy in our students, fostering globally aware citizens who are
                            ready to meet the challenges of the future.
                        </p>
                        {/* <div className="flex space-x-4 mt-5 ">
                            <button className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center  transform transition-all hover:scale-105">
                                <span>Our Facilities</span>
                                <FaArrowRight />
                            </button>
                            <button className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center space-x-2 transform transition-all hover:scale-105">
                                <span>Contact-us</span>
                                <FaArrowRight />
                            </button>
                        </div> */}

<div>
    {/* Desktop View (Visible on md and larger screens) */}
    <div className="hidden md:flex space-x-4 mt-5">
        <button onClick={()=>{
                            navigate('/gallery')
                        }} className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center transform transition-all hover:scale-105">
            <span>Gallery</span>
            <FaArrowRight />
        </button>
        <button onClick={()=>{
                            navigate('/contact')
                        }} className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center space-x-2 transform transition-all hover:scale-105">
            <span>Contact-us</span>
            <FaArrowRight />
        </button>
    </div>

    {/* Mobile View (Visible on sm and below) */}
    <div className="md:hidden flex flex-col items-center mt-5 space-y-4">
        <button onClick={()=>{
                            navigate('/contact')
                        }} className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center transform transition-all hover:scale-105">
            <span>Gallery</span>
            <FaArrowRight />
        </button>
        <button  className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center transform transition-all hover:scale-105">
            <span>Contact-us</span>
            <FaArrowRight />
        </button>
    </div>
</div>


                    </div>

                    {/* Right Side - Embedded Video */}
                    <div className="lg:w-1/2 w-full">
                        <div className="relative w-full h-56 md:h-72 lg:h-80">
                            <iframe
                                className="w-full h-full rounded-lg shadow-lg"
                                src="https://www.youtube.com/embed/CpD2VtPNIaY?si=xKLIisMYobVpNW9F"
                                title="School Video"
                                frameBorder="0"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>


            </div>

            <section className="relative bg-[url('https://img.freepik.com/free-vector/shiny-green-eco-happy-diwali-banner-with-text-space_1017-28655.jpg?semt=ais_hybrid')] bg-cover bg-center py-12 text-center px-6" data-aos="fade-up">
                <div className="absolute inset-0 bg-black opacity-50"></div> {/* Add overlay */}
                <h2 className="text-xl md:text-2xl font-bold text-white relative">OUR VISION</h2>
                <p className="text-white text-lg leading-relaxed mt-3 relative">Our vision is to provide a happy, caring and stimulating environment where children will recognize and achieve their fullest potential in their academic, creative, personal, physical, moral and cultural development.</p>
            </section>

            <div className="container mx-auto px-6 py-12" data-aos="fade-up">
                <div className="text-center mb-8">
                    <h2 className="text-xl md:text-2xl font-bold text-green-600 mb-4">
                        OUR PROGRAMMES
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div onClick={()=>{
                                    navigate('/pre-primary')
                                }} data-aos="fade-up">
                    <div className="relative rounded-lg shadow-lg cursor-pointer w-full h-64 overflow-hidden group">
                            {/* Image */}
                            <img
                                className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform group-hover:rotate-y-180"
                                src="https://img.freepik.com/free-vector/scene-with-boy-reading-book-room_1308-41168.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid"
                                alt="Pre-Primary Section"
                            />

                            {/* Hidden text (Appears on hover) */}
                            <div  className="absolute inset-0 bg-orange-500 text-white p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out flex flex-col justify-center items-center text-center">
                                <p className="">
                                    Young kids are raw, rebels and learn best when they know they are valued. SVN convent makes it its mission to identify the uniqueness in each child and bring out their best as they step into the world of formal schooling.
                                </p>

                                {/* Read More Button */}
                                <button  className="mt-4 flex items-center gap-2 bg-white text-green-600 font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-gray-200 transition duration-300">
                                    Read More <FaArrowRight />
                                </button>
                            </div>
                        </div>
                        <div className=" w-full text-center bg-opacity-50 p-4 ">
                            <p className="text-lg font-semibold">Pre-Primary Section</p>
                            <p className="text-sm">Nursery, LKG & UKG</p>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div onClick={()=>{
                                    navigate('/primary')
                                }} data-aos="fade-up">
                    <div className="relative rounded-lg shadow-lg cursor-pointer w-full h-64 overflow-hidden group">
                            {/* Image */}
                            <img
                                className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform group-hover:rotate-y-180"
                                src="https://img.freepik.com/free-vector/scene-with-boy-reading-book-room_1308-41168.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid"
                                alt="Pre-Primary Section"
                            />

                            {/* Hidden text (Appears on hover) */}
                            <div className="absolute inset-0 bg-orange-500 text-white p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out flex flex-col justify-center items-center text-center">
                                <p className="">
                                    Young kids are raw, rebels and learn best when they know they are valued. SVN convent makes it its mission to identify the uniqueness in each child and bring out their best as they step into the world of formal schooling.
                                </p>

                                {/* Read More Button */}
                                <button className="mt-4 flex items-center gap-2 bg-white text-green-600 font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-gray-200 transition duration-300">
                                    Read More <FaArrowRight />
                                </button>
                            </div>
                        </div>
                        <div className=" w-full text-center bg-opacity-50 p-4 ">
                            <p className="text-lg font-semibold">Primary Section</p>
                            <p className="text-sm">Standard 1-7</p>
                        </div>
                    </div>


                    {/* Card 3 */}
                    <div onClick={()=>{
                                    navigate('/high-school')
                                }} data-aos="fade-up">
                        <div className="relative rounded-lg shadow-lg cursor-pointer w-full h-64 overflow-hidden group">
                            {/* Image */}
                            <img
                                className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform group-hover:rotate-y-180"
                                src="https://img.freepik.com/free-vector/scene-with-boy-reading-book-room_1308-41168.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid"
                                alt="Pre-Primary Section"
                            />

                            {/* Hidden text (Appears on hover) */}
                            <div className="absolute inset-0 bg-orange-500 text-white p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out flex flex-col justify-center items-center text-center">
                                <p className="">
                                    Young kids are raw, rebels and learn best when they know they are valued. SVN convent makes it its mission to identify the uniqueness in each child and bring out their best as they step into the world of formal schooling.
                                </p>

                                {/* Read More Button */}
                                <button className="mt-4 flex items-center gap-2 bg-white text-green-600 font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-gray-200 transition duration-300">
                                    Read More <FaArrowRight />
                                </button>
                            </div>
                        </div>

                        <div className=" w-full text-center bg-opacity-50 p-4 ">
                            <p className="text-lg font-semibold">High Section</p>
                            <p className="text-sm">Standard 8-10</p>
                        </div>
                    </div>

                </div>


            </div>

            <section className="bg-[url('https://img.freepik.com/premium-vector/multi-layers-vector-background-with-abstract-topography-flowing-liquid-design-blue-colors_444390-14017.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid_sidr')] bg-fixed bg-cover bg-center" data-aos="fade-up">
                <div className="container mx-auto px-6 py-16 text-center">
                    <h2 className="text-xl md:text-2xl font-bold text-white relative mb-4">WHY CHOOSE SVN CONVENT AND ENGLISH HIGH SCHOOL ?</h2>
                    <p className="text-white text-lg leading-relaxed mt-3  mb-6 relative ">
                        SVN Convent and English High School is committed to providing a well-rounded education that focuses on both academic excellence and the development of strong moral values. With a dedicated and experienced faculty, each student receives personalized attention to help them excel not only in their studies but also in extracurricular activities. The school offers modern facilities, a safe and supportive environment, and emphasizes discipline and character building, ensuring students are well-prepared for both their academic future and personal growth.
                    </p>
                    <div className="flex justify-center items-center">
                        <button className="rounded-full py-3 px-6 font-medium cursor-pointer bg-green-500 text-white flex items-center  space-x-2 transform transition-all hover:scale-105">
                            <span>Our Facilities</span>
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
            </section>


            <div className="container mx-auto px-6 py-12" data-aos="fade-up">
                <div className="text-center mb-8">
                    <h2 className="text-xl md:text-2xl font-bold text-green-600">
                        FACILITIES
                    </h2>
                    <h2 className="text-md md:text-lg font-semibold text-blue-600 mb-4">
                        @ SVN CONVENT AND ENGLISH HIGH SCHOOL
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-aos="fade-up">
                    {/* Card 1 */}
                    <div onClick={()=>{
                            navigate('/smart-classroom')
                        }} className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer" data-aos="fade-up">
                        <img 
                            className="w-full h-64 object-cover"
                            src="https://img.freepik.com/free-vector/scene-with-boy-reading-book-room_1308-41168.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" // Replace with your image URL
                            alt="Pre-Primary Section"
                        />
                        <div className="absolute inset-0 flex flex-col justify-between p-4 text-white bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                            {/* Hover Content */}
                            <p className="text-lg">Discover our engaging Pre-Primary programs designed to foster creativity and early learning.</p>
                        </div>
                        {/* Default Text at the Bottom */}
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 p-4 text-white">
                            <p className="text-lg text-center font-semibold">SMART CLASSROOMS</p>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div onClick={()=>{
                            navigate('/science-lab')
                        }} className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer" data-aos="fade-up">
                        <img
                            className="w-full h-64 object-cover"
                            src="https://img.freepik.com/premium-vector/children-with-play-text-nature_43633-8902.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" // Replace with your image URL
                            alt="Primary Section"
                        />
                        <div className="absolute inset-0 flex flex-col justify-between p-4 text-white bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                            {/* Hover Content */}
                            <p className="text-lg">Explore our Primary Section focusing on essential academic growth and creativity.</p>
                        </div>
                        {/* Default Text at the Bottom */}
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 p-4 text-white">
                            <p className="text-lg text-center font-semibold">SCIENCE LAB</p>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div onClick={()=>{
                            navigate('/computer-lab')
                        }} className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer" data-aos="fade-up">
                        <img
                            className="w-full h-64 object-cover"
                            src="https://img.freepik.com/premium-photo/several-schoolchildren-with-backpacks-moving-down-square-while-going-school_274679-27884.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" // Replace with your image URL
                            alt="High School Section"
                        />
                        <div className="absolute inset-0 flex flex-col justify-between p-4 text-white bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                            {/* Hover Content */}
                            <p className="text-lg">Our High School program prepares students for academic excellence and future challenges.</p>
                        </div>
                        {/* Default Text at the Bottom */}
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 p-4 text-white">
                            <p className="text-lg text-center font-semibold">COMPUTER LAB</p>
                        </div>
                    </div>

                    {/* Card 4*/}
                    <div onClick={()=>{
                            navigate('/yoga')
                        }} className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer" data-aos="fade-up">
                        <img
                            className="w-full h-64 object-cover"
                            src="https://img.freepik.com/free-vector/scene-with-boy-reading-book-room_1308-41168.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" // Replace with your image URL
                            alt="Pre-Primary Section"
                        />
                        <div className="absolute inset-0 flex flex-col justify-between p-4 text-white bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                            {/* Hover Content */}
                            <p className="text-lg">Discover our engaging Pre-Primary programs designed to foster creativity and early learning.</p>
                        </div>
                        {/* Default Text at the Bottom */}
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 p-4 text-white">
                            <p className="text-lg text-center font-semibold">YOGA</p>
                        </div>
                    </div>

                    {/* Card 5 */}
                    <div onClick={()=>{
                            navigate('/van-facility')
                        }} className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer" data-aos="fade-up">
                        <img
                            className="w-full h-64 object-cover"
                            src="https://img.freepik.com/premium-vector/children-with-play-text-nature_43633-8902.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" // Replace with your image URL
                            alt="Primary Section"
                        />
                        <div className="absolute inset-0 flex flex-col justify-between p-4 text-white bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                            {/* Hover Content */}
                            <p className="text-lg">Explore our Primary Section focusing on essential academic growth and creativity.</p>
                        </div>
                        {/* Default Text at the Bottom */}
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 p-4 text-white">
                            <p className="text-lg text-center font-semibold">VAN FACILTY</p>
                        </div>
                    </div>

                    {/* Card 6 */}
                    <div onClick={()=>{
                            navigate('/sports')
                        }} className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer" data-aos="fade-up">
                        <img
                            className="w-full h-64 object-cover"
                            src="https://img.freepik.com/premium-photo/several-schoolchildren-with-backpacks-moving-down-square-while-going-school_274679-27884.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" // Replace with your image URL
                            alt="High School Section"
                        />
                        <div className="absolute inset-0 flex flex-col justify-between p-4 text-white bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                            {/* Hover Content */}
                            <p className="text-lg">Our High School program prepares students for academic excellence and future challenges.</p>
                        </div>
                        {/* Default Text at the Bottom */}
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 p-4 text-white">
                            <p className="text-lg text-center font-semibold">SPORTS</p>
                        </div>
                    </div>


                </div>


                <Testimonials />


            </div>


        </>
    );
};

export default Home;



